import styled, { css } from 'styled-components';
import { getFontStyle, rem } from '../../../utils';
const FLUER_MENU_SIZE = 48;
const FLUER_MENU_SPACING = 16;
const DESYGNER_MENU_SIZE = 78;
const DESYGNER_MENU_PADDING = 6;
export const StyledWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyleItemWrapper = css `
  display: flex;
  flex-direction: column;
  ${({ theme }) => css `
    z-index: ${theme.ZIndex.ZIndex.Elevated};
    box-shadow: ${`0 ${rem(1)} ${rem(2)} 0 rgba(0, 0, 0, 0.03)`},
      ${`0 ${rem(1)} ${rem(6)} -${rem(1)} rgba(0, 0, 0, 0.02)`},
      ${`0 ${rem(2)} ${rem(4)} 0 rgba(0, 0, 0, 0.02)`};
  `}

  ${({ variant, theme }) => variant === 'float'
    ? css `
          width: ${rem(FLUER_MENU_SIZE)};
          margin-left: ${rem(FLUER_MENU_SPACING)};
          border-radius: ${variant === 'float'
        ? rem(theme.Border.Radius.Large)
        : 0};
        `
    : css `
          width: ${rem(DESYGNER_MENU_SIZE)};
          padding: ${rem(DESYGNER_MENU_PADDING)};
        `}
`;
export const StyledNormalWrapper = styled.div `
  ${StyleItemWrapper};
  background-color: ${({ theme }) => theme.Components.Panel.Background};
`;
export const StyledPrimaryWrapper = styled.div `
  ${StyleItemWrapper};
  background-color: ${({ theme }) => theme.Color.Brand.Primary};
`;
export const Divider = styled.hr `
  width: 100%;
  margin: 0;
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
`;
const activeItemStyle = css `
  ${({ theme, variant, isFeatured }) => variant === 'float'
    ? css `
          background-color: ${isFeatured
        ? theme.Color.Brand.Primary
        : theme.Components.Panel.BackgroundHover};
          color: ${theme.Color.Neutrals.Dark};
          svg {
            fill: ${isFeatured
        ? theme.Color.Neutrals.Paper
        : theme.Color.Neutrals.Dark};
          }
        `
    : css `
          background-color: ${theme.Color.Brand.Lightest};
          color: ${theme.Color.Brand.Primary};
          svg {
            fill: ${theme.Color.Brand.Primary};
          }
        `}
`;
export const StyledNavItemContainer = styled.div `
  padding: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)} 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const NavItem = styled.a `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({ theme, variant }) => css `
    min-height: ${rem(theme.Spacing.Size.XLarge)};
    gap: ${rem(theme.Spacing.Size.XXSmall)};
    border-radius: ${rem(theme.Border.Radius.Medium)};
    color: ${theme.Color.Neutrals.Dark};
    padding: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
    min-width: ${variant === 'float' ? rem(theme.Spacing.Size.XLarge) : '100%'};
  `}

  ${({ active }) => active && activeItemStyle}

  ${({ theme, isFeatured }) => isFeatured &&
    css `
      svg {
        fill: ${theme.Color.NeutralsFixed.Paper};
      }
    `}

  &:hover {
    ${activeItemStyle}
  }
`;
export const NavItemLabel = styled.label `
  width: 100%;
  ${getFontStyle('Small')}
  text-align: center;
`;
//# sourceMappingURL=Navigation.style.js.map